import type { EmojiClickData } from "emoji-picker-react";
import EmojiPicker, { EmojiStyle, Theme } from "emoji-picker-react";

import { useOwnTheme } from "@/contexts/theme-context";
import { cn } from "@/utils/lib";

type EmojiSelectorProps = {
  onEmojiClick: (emoji: EmojiClickData) => void;
};

export const EmojiSelector = ({ onEmojiClick }: EmojiSelectorProps) => {
  const { darkTheme } = useOwnTheme();

  return (
    <div
      className={cn(
        "relative isolate w-full",
        // Some emoji picker style overrides
        "[&_div>.epr-emoji-native]:text-[38px]!",
        `
          [&_.epr-category-nav]:no-scrollbar [&_.epr-category-nav]:max-w-full
          [&_.epr-category-nav]:justify-start [&_.epr-category-nav]:gap-1
          [&_.epr-category-nav]:overflow-x-auto
          [&_.epr-category-nav]:overflow-y-hidden [&_.epr-category-nav]:pr-2
          [&_.epr-category-nav]:pb-1
          [&_.epr-category-nav>button]:shrink-0
          [&_.epr-emoji-category-label]:backdrop-blur-sm
          [&_.epr-header]:bg-background/90 [&_.epr-header]:backdrop-blur-sm
        `,
      )}
    >
      <EmojiPicker
        onEmojiClick={onEmojiClick}
        theme={darkTheme ? Theme.DARK : Theme.LIGHT}
        lazyLoadEmojis
        emojiStyle={EmojiStyle.NATIVE}
        previewConfig={{ showPreview: false }}
        width="100%"
        style={{
          // @ts-expect-error bad types
          "--epr-bg-color": "transparent",
          "--epr-search-input-bg-color": "var(--input)",
          "--epr-search-input-bg-color-active": "var(--input)",
          "--epr-search-border-color": "var(--border-light)",
          "--epr-search-border-color-active": "var(--foreground)",
          "--epr-category-label-bg-color":
            "hsl(from var(--background) h s l / 0.92)",
          "--epr-header-padding": "15px 10px 5px 10px",
          "--epr-picker-border-color": "transparent",
        }}
      />
    </div>
  );
};
